import React from "react"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import { Accordion } from "react-bootstrap"
import _ from "lodash"
import PropTypes from "prop-types"
import { Field, FormSpy } from "react-final-form"
import { FieldArray } from "react-final-form-arrays"

import {
  FIXED_REMUNERATION,
  SUPPORTED_PLANT_TYPES_OPTIONS,
  SUPPORTED_SERVICE_FEE_UNIT_TYPES_OPTIONS,
} from "../../../../../constants"
import PriceCalculationServiceFeeForm from "./PriceCalculationServiceFeeForm"
import {
  MAIN_COLOR,
  SECONDARY_COLOR,
  NO_ACTIVE_BG_COLOR,
  NO_ACTIVE_COLOR,
} from "../../../../../constants/css"
import Button from "../../../../common/styles/Button"
import AccordionItem from "../../../../common/lib/Accordion"
import {
  FlexFormCol,
  OuterFormColLeft,
} from "../../../../common/styles/FormStyles"
import SelectWrapper from "../../../../common/forms/SelectWrapper"
import InputWrapper from "../../../../common/forms/InputWrapper"
import { required } from "redux-form-validators"
import {
  parseStrToNumber,
  getLabelText,
} from "../../../../../utils/commonUtils"
import { ReactComponent as Info } from "../../../../../images/icons/INfo.svg"

export function getPlantTypeOptions(options, addedPlantTypes) {
  // displays plant types except already added ones
  if (addedPlantTypes.length === 0) {
    return options
  }

  return _.filter(options, (item) => {
    return !addedPlantTypes.includes(item.value)
  })
}

class PlantTypeItemForm extends React.Component {
  render() {
    const { rowName, disabled } = this.props
    return (
      <>
        <Row>
          <Col md={6} lg={6}>
            <Field
              name={`${rowName}.display_name`}
              component={InputWrapper}
              type="text"
              labelText="Display Name der Erzeugungsart"
              className="mt-4 mb-5"
              infoIcon={<Info />}
              infoIconTooltip="Der Display Name wird in allen E-Mails und PDF Dokumenten verwendet."
              disabled={disabled}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12} lg={12}>
            <FormSpy subscription={{ values: true }}>
              {({ values }) => {
                const rowValues = _.get(values, rowName, {})
                const minPriceNetto =
                  rowValues.minimum_price_netto !== undefined
                    ? rowValues.minimum_price_netto
                    : null

                const serviceFees = rowValues.service_fees || []
                let distributionCostsIndex = null
                serviceFees.forEach((fee, i) => {
                  if (
                    fee?.classification === "distribution_cost_fee_producer"
                  ) {
                    distributionCostsIndex = i
                  }
                })

                return (
                  <FieldArray name={`${rowName}.service_fees`}>
                    {({ fields }) => (
                      <PriceCalculationServiceFeeForm
                        fields={fields}
                        minPriceNetto={minPriceNetto}
                        distributionCostsIndex={distributionCostsIndex}
                        disabled={disabled}
                      />
                    )}
                  </FieldArray>
                )
              }}
            </FormSpy>
          </Col>
        </Row>
        <Row>
          <Col lg={6} md={6}>
            <Field
              name={`${rowName}.minimum_price_netto`}
              component={InputWrapper}
              type="number"
              labelText="Optional: Minimales monatliches Entgelt"
              unit="ct/Monat"
              className="mt-5 mb-4"
              parse={(x) => parseFloat(x)}
              disabled={disabled}
            />
          </Col>
        </Row>
      </>
    )
  }
}

class PlantTypeForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      plantTypeOptions: [],
      justCreatedAccordionIndex: 0,
    }
  }

  componentDidMount() {
    const addedPlantTypes = this.props.fields.map((item, index) => {
      return this.props.fields.value[index].plant_type
    })
    const plantTypeOptions = getPlantTypeOptions(
      SUPPORTED_PLANT_TYPES_OPTIONS,
      addedPlantTypes,
    )
    this.setState({ plantTypeOptions })
  }

  componentDidUpdate(prevProps) {
    if (prevProps.fields !== this.props.fields) {
      const addedPlantTypes = this.props.fields.map((item, index) => {
        return this.props.fields.value[index].plant_type
      })
      const plantTypeOptions = getPlantTypeOptions(
        SUPPORTED_PLANT_TYPES_OPTIONS,
        addedPlantTypes,
      )
      this.setState({ plantTypeOptions })
    }
  }

  renderEnabledPlantTypes() {
    const { fields } = this.props
    return fields.map((plant, index) => {
      const isFirstItem = index === 0
      const isJustCreatedItem =
        this.state.justCreatedAccordionIndex === fields.length - 1
      return (
        <div data-testid="plant-accordion" key={index}>
          <AccordionItem
            title={getLabelText(
              SUPPORTED_PLANT_TYPES_OPTIONS,
              fields.value[index]?.plant_type,
            )}
            withDelete={true}
            index={index}
            deleteHandler={this.deleteEnabledPlantType.bind(this)}
            expanded={isFirstItem || isJustCreatedItem}
            key={index}
            disabled={this.props.disabled}
          >
            <PlantTypeItemForm
              rowName={plant}
              index={index}
              disabled={this.props.disabled}
            />
          </AccordionItem>
        </div>
      )
    })
  }

  deleteEnabledPlantType(index) {
    if (this.props.fields.length > 0) {
      this.props.fields.remove(index)
    }
  }

  addPlantTypeItem(selectedPlantType) {
    const selected = selectedPlantType
    const alreadyAdded = _.find(
      this.props.fields.value || [],
      (plant) => plant.plant_type === selected,
    )
    this.setState({ justCreatedAccordionIndex: this.props.fields.length })
    if (selected && alreadyAdded === undefined) {
      this.props.fields.push({ plant_type: selected })
    }
  }

  render() {
    const { fields, disabled } = this.props
    return (
      <FormSpy subscription={{ values: true }}>
        {({ values }) => {
          const paymentModel = values.payment_model
          const selectedPlantType = values.selectedPlantTypeField
          return (
            <>
              {paymentModel === FIXED_REMUNERATION ? (
                <Row>
                  <Col md={12} lg={12}>
                    <AccordionItem
                      title="FESTPREISVERGÜTUNG"
                      index={-2}
                      expanded={true}
                      key={-2}
                    >
                      <Row>
                        <FlexFormCol md={6} lg={6}>
                          <Field
                            name="remuneration_price_netto"
                            labelText="Höhe des Festpreises"
                            component={InputWrapper}
                            validate={required()}
                            type="number"
                            parse={parseStrToNumber}
                            className="mt-4 mr-3"
                            disabled={disabled}
                          />
                          <Field
                            defaultVal={
                              SUPPORTED_SERVICE_FEE_UNIT_TYPES_OPTIONS[0]
                            }
                            name="remuneration_unit"
                            labelText="Monetäre Einheit"
                            component={SelectWrapper}
                            optionsList={
                              SUPPORTED_SERVICE_FEE_UNIT_TYPES_OPTIONS
                            }
                            width="300px"
                            arrowMargin="6px"
                            className="mt-4"
                            disabled={true}
                            infoIcon={<Info />}
                            infoIconTooltip="Eine prozentuale Gebühr wird in der Einspeiserechnung auf die netto Gutschrift für die eingespeiste Strommenge angewandt."
                            tooltipMarginLeft="10px"
                          />
                        </FlexFormCol>
                        <Col md={6} lg={6}>
                          <Field
                            name="remuneration_display_name"
                            component={InputWrapper}
                            type="text"
                            validate={required()}
                            labelText="Display Name des Festpreises"
                            className="mt-4"
                            disabled={disabled}
                          />
                        </Col>
                      </Row>
                    </AccordionItem>
                  </Col>
                </Row>
              ) : null}
              <Row>
                <OuterFormColLeft md={6} lg={6} className="mb-5 mr-3">
                  <Field
                    name="selectedPlantTypeField"
                    labelText="Erzeugungsart"
                    component={SelectWrapper}
                    optionsList={this.state.plantTypeOptions}
                    disabled={disabled}
                  />
                </OuterFormColLeft>
                <Col md={5} lg={5} className="mb-5">
                  <Button
                    type="button"
                    color={disabled ? NO_ACTIVE_BG_COLOR : MAIN_COLOR}
                    colorText={disabled ? NO_ACTIVE_COLOR : SECONDARY_COLOR}
                    onClick={() => this.addPlantTypeItem(selectedPlantType)}
                    disabled={disabled}
                    hoverCursor={disabled ? "default" : "pointer"}
                  >
                    Erzeugungsart hinzufügen
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col md={12} lg={12}>
                  {fields.length > 0 && (
                    <Accordion defaultActiveKey={fields.value[0]?.plant_type}>
                      {this.renderEnabledPlantTypes()}
                    </Accordion>
                  )}
                </Col>
              </Row>
            </>
          )
        }}
      </FormSpy>
    )
  }
}

export default PlantTypeForm

PlantTypeItemForm.propTypes = {
  rowName: PropTypes.string,
  disabled: PropTypes.bool,
  index: PropTypes.number,
}

PlantTypeForm.propTypes = {
  fields: PropTypes.object,
  disabled: PropTypes.bool,
}
